<template lang="pug">
  communications-layout
    //- Displays the Error Snackbar on the bottom of the page
    v-snackbar(:value="conversationsError" color="error")
      div {{ conversationsErrorMessage }}

    //- Displays the Success Snackbar on the bottom of the page
    v-snackbar(:value="conversationsSuccess" color="success")
      div {{ conversationsSuccessMessage }}

    //- Displays the Error Snackbar on the bottom of the page
    v-snackbar(:value="templatesError" color="error")
      div {{ templatesErrorMessage }}

    //- Displays the Success Snackbar on the bottom of the page
    v-snackbar(:value="templatesSuccess" color="success")
      div {{ templatesSuccessMessage }}

    v-snackbar(:value="resendOTPisError" color="error")
      div {{ resendOTPError }}

    v-snackbar(:value="resendOTPisSuccess" color="success")
      div Verification re-sent successfully. Check your mobile.

    v-tabs.tabs-wrapper(
      :style="{ width: '100%' }"
      slider-color="primary"
      color="transparent"
      :value="selectedTab"
    )
      v-tab(key="1" @click="selectTextTab") Text Conversations
      v-tab(v-if="gatedAction !== gatedActions.Blocked" key="2" @click="selectTextConsoleTab") Text Management
      v-tab-item(transition="none" reverse-transition="none")
        v-flex.pa-0(v-if="!isTextConsoleTabSelected" xs12)
          v-flex.py-0(xs12)
            v-flex(x12)
              a.trailback(@click="handleGoBack")
                v-icon(small) keyboard_arrow_left
                span Back

          v-layout
            v-flex.xs6.md8
              v-text-field.text-search-style(
                data-cy="search-conversations"
                solo
                prepend-inner-icon="search"
                v-model="searchValue"
                label="Search Conversations by Contact"
                hide-details
              )
            v-flex.xs6.md1
              v-menu(offset-y data-cy="text-filter")
                v-toolbar-title.liondesk(dense slot="activator")
                  span {{ filterTextsValue }}
                  v-icon(color="primary" right) arrow_drop_down
                v-list
                  v-list-tile(
                    v-for="searchMenuItem in searchMenuItems"
                    :key="searchMenuItem.value"
                    @click="setInitialConversations(searchMenuItem.value)"
                  )
                    v-list-tile-title(data-cy="text-filter-item") {{ searchMenuItem.text }}
            v-flex.xs6.md3.offset-md6.text-xs-right
              v-btn.primary(flat @click="composeNewText") Compose a Text

          v-layout(row height="100%")
            conversations(
              v-if="conversationsHaveLoaded"
              :conversations="conversations"
              :initial-direction="desiredDirection"
              @load-more-callback="increaseConversationsPagination"
              v-model="desiredConversation"
            )
            chat-history(
              :send-message-callback="sendMessageCallback"
              :send-button-disabled="sendingTextInProgress"
              :initial-contact-info="desiredConversation"
              :is-loading="conversationsInProgress"
              :conversations="conversations"
              :current-user="user"
              @load-more-callback="increaseChatHistoryPagination"
              @compose-new-text="composeNewText"
              v-model="chatHistory"
            )

      v-tab-item(transition="none" reverse-transition="none")
        v-flex.pa-0(v-if="isTextConsoleTabSelected" xs12)
          v-flex.py-0(xs12)
            v-flex(x12)
              a.trailback(@click="handleGoBack")
                v-icon(small) keyboard_arrow_left
                span Back
          v-layout.ma-3(column height="100%")
            text-console(@openRegistrationFlowByKeyword="openRegistrationFlowByKeyword")
            messaging-health
            opt-in-form-builder
            sole-prop-flow-modal
</template>


<script>
import { mapState, mapMutations, mapGetters, createNamespacedHelpers, mapActions } from 'vuex';
import CommunicationsLayout from '@/Communications/Layout';
import TitleBar from '@/Core/components/TitleBar';
import { debounce } from '@/Core/utilities';
import { DIRECTIONS } from '@/Communications/config';
import GoBackNavigation from '@/Contacts/mixins/goBackNavigation';
import Conversations from './components/Conversations';
import ChatHistory from './components/ChatHistory';
import TextConsole from './components/TextConsole';
import MessagingHealth from './components/MessagingHealth';
import OptInFormBuilder from './components/OptInFormBuilder';
import { STEPS_SOLE_PROPRIETOR } from '../a2p/config';
import sendSmsGate from '../Core/mixins/send-sms-gate';
import { GATED_ACTIONS } from '../Core/config/gated-actions';
import { TEXT_TAB, TEXT_MANAGEMENT_TAB } from './config';
import SolePropFlowModal from '@/Core/components/SolePropFlowModal';

const { mapState: mapTemplatesState } = createNamespacedHelpers('templates');
const { mapActions: mapConversationsActions, mapState: mapConversationsState } =
  createNamespacedHelpers('conversations');

const { mapActions: mapSoleProprietorActions, mapState: mapSoleProprietorState } =
  createNamespacedHelpers('registerSoleProprietorA2p');

const { mapActions: mapUserSmsErrorRatesActions } = createNamespacedHelpers(
  'userSmsErrorRates',
);

const optInOptions = {
  ORIGINAL_SMS: 'should send original sms',
  SMS_AND_OPT_IN: 'should send opt in',
};

export default {
  components: {
    Conversations,
    ChatHistory,
    CommunicationsLayout,
    TitleBar,
    TextConsole,
    SolePropFlowModal,
    MessagingHealth,
    OptInFormBuilder,
  },
  mixins: [GoBackNavigation, sendSmsGate],
  props: {
    route: String,
  },
  data() {
    return {
      directions: DIRECTIONS,
      desiredDirection: DIRECTIONS[0],
      searchValue: '', // Stores the value from the search bar
      desiredConversation: {}, // Stores the desired conversation on click
      conversationsPagination: 0, // Measures how many items we should skip to the BE call
      chatHistoryPagination: 0, // Measures how many items we should skip to the BE call
      searchMenuItems: [
        { value: 'all', text: 'All' },
        { value: 'received', text: 'With Replies' },
      ],
      filterTextsValue: 'All',
      gatedActions: GATED_ACTIONS,
      currentTextTab: TEXT_TAB,
    };
  },
  computed: {
    ...mapState({
      user: state => state.userInformation.user,
      addRegisterFeeAddonsSuccess: state => state.payment.addRegisterFeeAddonsSuccess,
    }),
    ...mapSoleProprietorState(['registrationModalClose']),
    ...mapConversationsState([
      'chatHistory',
      'conversations',
      'hasMoreConversationsToLoad',
      'conversationsError',
      'conversationsErrorMessage',
      'conversationsSuccess',
      'conversationsSuccessMessage',
      'sendingTextInProgress',
      'conversationsInProgress',
      'resendOTPisError',
      'resendOTPError',
      'resendOTPisSuccess',
      'has10dlcRegister',
      'isRegistration10dlcIncomplete',
    ]),
    ...mapTemplatesState([
      'templatesError',
      'templatesErrorMessage',
      'templatesSuccess',
      'templatesSuccessMessage',
    ]),
    ...mapGetters('userInformation', ['userHasFeatureFlag']),
    conversationsHaveLoaded() {
      return !this.conversations || this.conversations.length;
    },
    selectedTab() {
      return this.route === TEXT_TAB ? 0 : 1;
    },
    isTextConsoleTabSelected() {
      return this.route === TEXT_MANAGEMENT_TAB;
    },
  },
  async created() {
    this.getIsUserBlocked();
    this.getRates();
    this.setInitialConversations();
    this.conversationsClearErrors();
    this.conversationsClearSuccess();
    this.templatesClearErrors();
    this.templatesClearSuccess();
    if (!this.has10dlcRegister || this.isRegistration10dlcIncomplete) {
      await this.checkFor10dlcRegister();
    }
    this.currentTextTab = this.$route.name;
  },
  watch: {
    // Updates the search string upon a 500ms typing pause to prevent spamming
    searchValue(value) {
      if (value.length === 0 || value.length > 2) {
        debounce(this.setInitialConversations, [value]);
      }
    },
    desiredConversation: {
      async handler(conversation) {
        await this.resetChatHistory(conversation);
      },
      deep: true,
    },
    addRegisterFeeAddonsSuccess: {
      handler(value) {
        if (!value) { return };
        this.setStep(STEPS_SOLE_PROPRIETOR.STATUS);
        this.setShowRegistrationFlowModal({ bool: true, action: this.registrationModalClose });
        this.setAddRegisterFeeAddonsSuccess(false);
      },
    },
  },

  methods: {
    ...mapMutations({
      conversationsClearErrors: 'conversations/clearErrors',
      conversationsClearSuccess: 'conversations/clearSuccess',
      resetChat: 'conversations/resetMessage',
      templatesClearErrors: 'templates/clearErrors',
      templatesClearSuccess: 'templates/clearSuccess',
    }),
    ...mapConversationsActions([
      'getConversations',
      'getChatHistory',
      'sendMessages',
      'checkFor10dlcRegister',
      'resendSolePropOTP',
    ]),
    ...mapSoleProprietorActions([
      'setStep',
      'setShowRegistrationFlowModal',
    ]),
    ...mapActions('payment', ['setAddRegisterFeeAddonsSuccess']),
    ...mapUserSmsErrorRatesActions(['getIsUserBlocked', 'getRates']),
    /**
     * Resets the chat history to the given conversation
     *
     * @param {Array} conversation The array of texts between a user and a contact
     */
    async resetChatHistory(conversation) {
      this.resetChat();
      await this.getChatHistory({ offset: 0, conversation });
      this.chatHistoryPagination = this.chatHistory.length;
    },
    /**
     * Sends the new text and resets the chat history when it finishes, either
     * on error or on success.
     */
    async sendMessageCallback(messagePayload) {
      let { contacts } = messagePayload;
      const { optInSelection } = messagePayload.sendOptions;
      
      contacts.forEach(contact => {
        if (optInSelection === optInOptions.ORIGINAL_SMS) {
          contact.should_send_opt_in = false;
          contact.should_send_original_sms = true;
          return;
        }

        if (optInSelection === optInOptions.SMS_AND_OPT_IN) {
          contact.should_send_opt_in = true;
          contact.should_send_original_sms = true;
        }
      });

      contacts = contacts.map(contact => ({
        id: contact.id,
        mobile_phone: contact.mobile_phone,
        should_send_original_sms: contact.should_send_original_sms,
        should_send_opt_in: contact.should_send_opt_in
      }));

      const payload = {
        ...messagePayload,
        contacts,
      }

      await this.sendMessages(payload);
      await this.resetChatHistory(this.desiredConversation);
    },
    /**
     * Re-initializes the list of conversations and affected variables
     * Reads from the local state 'desiredDirection' to determine the direction
     */
    async setInitialConversations(type) {
      if (type === 'received') {
        this.filterTextsValue = 'With replies';
      } else {
        this.filterTextsValue = 'All';
      }
      const searchValues = this.searchValue ? this.searchValue.split(' ') : null;
      await this.getConversations({
        skip: 0,
        searchValues,
        type,
      });

      this.conversationsPagination = this.conversations.length;
      // [OPTIONAL] By default, display the first item on the list of conversations
      if (this.conversations && !this.templatesClearErrors.id) {
        this.desiredConversation = this.conversations[0];
      }
    },
    /**
     * Obtain new data with a desired pagination, to be appended to the list of conversations
     */
    async increaseConversationsPagination() {
      const searchType = this.searchMenuItems.find(
        v => v.text.toLowerCase() === this.filterTextsValue.toLowerCase(),
      );
      const searchValues = this.searchValue ? this.searchValue.split(' ') : null;
      const type = searchType && searchType.value;
      await this.getConversations({
        skip: this.conversationsPagination,
        searchValues,
        type,
      });
      if (this.hasMoreConversationsToLoad) {
        this.conversationsPagination = this.conversations.length;
      }
    },
    /**
     * Obtain new data with desired pagination, to be appended to the list of chat history
     */
    async increaseChatHistoryPagination() {
      await this.getChatHistory({
        offset: this.chatHistoryPagination,
        conversation: this.desiredConversation,
      });
      if (this.chatHistory.length) {
        // If there are new chat history, increase the pagination
        this.chatHistoryPagination = this.chatHistory.length;
      }
    },
    /**
     * Redirects to sending bulk text page
     */
    composeNewText() {
      this.$router.push('/communications/text/bulk');
    },
    changeRoute(routeName) {
      if (this.route !== routeName) {
        this.$router.push({ name: routeName });
      }
    },
    openRegistrationFlowByKeyword(keyword) {
      switch (keyword) {
        case 'ein':
          this.setStep(STEPS_SOLE_PROPRIETOR.DECISION);
          this.setShowRegistrationFlowModal({ bool: true });
          break;
        case 'brand':
          this.setStep(STEPS_SOLE_PROPRIETOR.SOLE_PROPRIETOR);
          this.setShowRegistrationFlowModal({ bool: true });
          break;
        case 'standard_brand':
          this.$router.push('/a2p-lowstandardbrand-registration');
          break;
        case 'fee':
          this.setStep(STEPS_SOLE_PROPRIETOR.PAYMENT);
          this.setShowRegistrationFlowModal({ bool: true });
          break;
        case 'status':
          this.setStep(STEPS_SOLE_PROPRIETOR.STATUS);
          this.setShowRegistrationFlowModal({ bool: true });
          break;
        case 'campaign':
          this.setStep(STEPS_SOLE_PROPRIETOR.CAMPAIGN);
          this.setShowRegistrationFlowModal({ bool: true });
          break;
        case 'standard_campaign':
          this.$router.push('/a2p-lowstandardbrand-registration#campaign');
          break;
        case 'text':
          this.resendSolePropOTP();
          break;
      }
    },
    selectTextConsoleTab() {
      this.currentTextTab = TEXT_MANAGEMENT_TAB;
      this.changeRoute(TEXT_MANAGEMENT_TAB);
    },
    selectTextTab() {
      this.currentTextTab = TEXT_TAB;
      this.changeRoute(TEXT_TAB);
    },
  },
};
</script>
<style scoped lang="scss">
.text-filter-icon.theme--light.v-icon {
  font-size: 90pt;
}

.filter-message-container {
  flex-direction: column;

  .message {
    color: rgba(0, 0, 0, 0.54);
    font-size: 16px;
  }
}

.tabs-wrapper ::v-deep .v-window__container {
  height: 100% !important;
}
</style>
